<div class="container">
    <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 col-sm-12">
            <div class="registro-card" style="padding-top:100px; padding-bottom: 100px;">
                <form [formGroup]="registrarForm">

                    <!-- Título con cinta -->
                    <h1 class="section-title">Crea tu cuenta</h1>
                    <!-- <p class="text-center textGris mb-4">Haz el seguimiento de tus pedidos</p> -->

                    <!-- Fila 1: Nombres y Apellidos -->
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <div class="md-form">
                                <label for="txtNombre" class="required">Nombres</label>
                                <input
                                    mdbInput
                                    [ngClass]="displayFieldCss('txtNombre')"
                                    formControlName="txtNombre"
                                    type="text"
                                    id="txtNombre"
                                    class="form-control"
                                    placeholder="Ingrese sus nombres"
                                    (blur)="validarCampo('txtNombre')"
                                >
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="md-form">
                                <label for="txtApellidos" class="required">Apellidos</label>
                                <input
                                    mdbInput
                                    [ngClass]="displayFieldCss('txtApellidos')"
                                    formControlName="txtApellidos"
                                    type="text"
                                    id="txtApellidos"
                                    class="form-control"
                                    placeholder="Ingrese sus apellidos"
                                    (blur)="validarCampo('txtApellidos')"
                                >
                            </div>
                        </div>
                    </div>

                    <!-- Fila 2: Tipo de Documento y Número de Documento -->
                    <div class="row">
                        <div class="col-md-4 col-sm-12">
                            <div class="form-group-select">
                                <label for="txtTipoDocumento" class="lbl_inputs required">Tipo de Documento</label>
                                <select
                                    class="browser-default custom-select"
                                    [ngClass]="displayFieldCss('txtTipoDocumento')"
                                    (change)="onChangeTipoDoc($event.target.value)"
                                    formControlName="txtTipoDocumento"
                                    id="txtTipoDocumento"
                                    (blur)="validarCampo('txtTipoDocumento')"
                                >
                                    <option selected value="" disabled>Seleccionar</option>
                                    <option *ngFor="let tipo of listTipoDocumento.response.list" value="{{tipo.masterId}}">{{tipo.masterDescription}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-8 col-sm-12">
                            <div class="form-group-input">
                                <label for="txtNroDocumento" class="lbl_inputs required">Número de Documento</label>
                                <input
                                    type="text"
                                    [ngClass]="displayFieldCss('txtNroDocumento')"
                                    [maxLength]="maxLengthTxtNroDocumento"
                                    formControlName="txtNroDocumento"
                                    id="txtNroDocumento"
                                    (keypress)="fc_ValTextDocumento($event)"
                                    class="form-control"
                                    placeholder="12345678"
                                    (blur)="validarCampo('txtNroDocumento')"
                                >
                            </div>
                        </div>
                    </div>

                    <!-- Fila 3: Correo y Teléfono -->
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <div class="md-form">
                                <label for="txtCorreo" class="required">Correo electrónico</label>
                                <input
                                    mdbInput
                                    type="email"
                                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$"
                                    [ngClass]="displayFieldCss('txtCorreo')"
                                    formControlName="txtCorreo"
                                    id="txtCorreo"
                                    class="form-control"
                                    placeholder="ejemplo@correo.com"
                                    (blur)="validarCampo('txtCorreo')"
                                >
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="md-form">
                                <label for="txtTelefono" class="required">Número de Teléfono</label>
                                <input
                                    mdbInput
                                    type="text"
                                    [ngClass]="displayFieldCss('txtTelefono')"
                                    formControlName="txtTelefono"
                                    id="txtTelefono"
                                    class="form-control"
                                    placeholder="987654321"
                                    (blur)="validarCampo('txtTelefono')"
                                >
                            </div>
                        </div>
                    </div>

                    <!-- Fila 4: Fecha de Nacimiento -->
                    <div class="row">
                        <div class="col-12">
                            <div class="md-form">
                                <label for="txtFechaNacimiento" class="required">Fecha de Nacimiento</label>
                                <input
                                    mdbInput
                                    type="date"
                                    [ngClass]="displayFieldCss('txtFechaNacimiento')"
                                    formControlName="txtFechaNacimiento"
                                    id="txtFechaNacimiento"
                                    class="form-control"
                                    (blur)="validarCampo('txtFechaNacimiento')"
                                >
                            </div>
                        </div>
                    </div>

                    <!-- Fila 5: Contraseñas -->
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <div class="md-form">
                                <label for="txtPassword" class="required">Contraseña</label>
                                <input
                                    mdbInput
                                    type="password"
                                    [ngClass]="displayFieldCss('txtPassword')"
                                    formControlName="txtPassword"
                                    id="txtPassword"
                                    class="form-control"
                                    placeholder="Mínimo 6 caracteres"
                                    (blur)="validarCampo('txtPassword')"
                                >
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="md-form">
                                <label for="txtPassword2" class="required">Confirmar Contraseña</label>
                                <input
                                    mdbInput
                                    type="password"
                                    [ngClass]="displayFieldCss('txtPassword2')"
                                    formControlName="txtPassword2"
                                    id="txtPassword2"
                                    class="form-control"
                                    placeholder="Repita su contraseña"
                                    (blur)="validarCampo('txtPassword2')"
                                >
                            </div>
                        </div>
                    </div>

                    <!-- Checkbox de Tratamiento de Datos Adicionales -->
                    <div class="row mt-3">
                        <div class="col-12">
                            <div class="form-check" style="display: flex; align-items: flex-start; gap: 10px;">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="chkTratamientoDatos"
                                    [(ngModel)]="acceptAdditionalDataTreatment"
                                    [ngModelOptions]="{standalone: true}"
                                    style="width: 18px; height: 18px; min-width: 18px; cursor: pointer; margin-top: 3px;"
                                >
                                <label class="form-check-label" for="chkTratamientoDatos" style="font-size: 14px; cursor: pointer; text-align: left;">
                                    He leído y acepto el <span style="text-decoration: underline; color: #c41e3a; cursor: pointer;" (click)="onClickTratamientoDatos(); $event.stopPropagation()">Tratamiento de mis datos para fines adicionales</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Botón de Registro -->
                    <div class="row mt-4">
                        <div class="col-12 text-center">
                            <button
                                type="button"
                                class="btn btnRegistrar"
                                (click)="registrar()"
                                [disabled]="registrarForm.invalid"
                            >
                                <i class="fas fa-user-plus"></i>
                                Registrarse
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</div>
